/**
 * 컬럼 너비 리사이즈 (P9-⑦) — `.lumir-col-resize` 핸들 드래그로 인접 두 컬럼의 width(flex-grow) 조정.
 * 합(totalW)은 유지하고 픽셀 델타를 비율로 환산. 드롭 시 dataset.columnWidth 갱신 + onChange(커밋).
 */

const MIN_PX = 48;

export function attachColumnControls(editorEl, opts) {
  opts = opts || {};
  const onChange = typeof opts.onChange === "function" ? opts.onChange : () => {};
  let drag = null;

  function setW(col, w) {
    col.style.flexGrow = String(w);
    col.style.flexBasis = "0";
    col.style.flexShrink = "1";
    col.dataset.columnWidth = String(Math.round(w * 1000) / 1000);
  }
  function onDown(e) {
    const h = e.target.closest && e.target.closest(".lumir-col-resize");
    if (!h || !editorEl.contains(h)) return;
    const prev = h.previousElementSibling;
    const next = h.nextElementSibling;
    if (!prev || !next || !prev.classList.contains("lumir-column") || !next.classList.contains("lumir-column")) return;
    e.preventDefault();
    const pr = prev.getBoundingClientRect();
    const nr = next.getBoundingClientRect();
    const wPrev = parseFloat(prev.style.flexGrow) || 1;
    const wNext = parseFloat(next.style.flexGrow) || 1;
    drag = { prev, next, startX: e.clientX, prevPx: pr.width, totalPx: pr.width + nr.width, totalW: wPrev + wNext };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  }
  function onMove(e) {
    if (!drag) return;
    const dx = e.clientX - drag.startX;
    if (drag.totalPx <= 0) return;
    const newPrevPx = Math.max(MIN_PX, Math.min(drag.totalPx - MIN_PX, drag.prevPx + dx));
    const ratio = newPrevPx / drag.totalPx;
    const newPrevW = drag.totalW * ratio;
    setW(drag.prev, newPrevW);
    setW(drag.next, drag.totalW - newPrevW);
  }
  function onUp() {
    document.removeEventListener("mousemove", onMove);
    document.removeEventListener("mouseup", onUp);
    if (drag) { drag = null; onChange(); }
  }
  editorEl.addEventListener("mousedown", onDown);

  return {
    destroy() {
      editorEl.removeEventListener("mousedown", onDown);
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    },
  };
}
